import React from 'react';
import ListarEgresos from '../../../components/insumos/egresos/ListarEgresos';
import { PageWrapper } from '../../../components/common';

const ListarEgresosPage: React.FC = () => {
  return (
    <PageWrapper>
      <ListarEgresos />
    </PageWrapper>
  );
};

export default ListarEgresosPage;
